export default {
  detail: '商户详情',
  backpage: '返回上一页',
  basic: '商户基本信息',
  agency: '代理人',
  merchantkey: '商户密钥',
  indetails: '商户详细信息',
  merchantcode: '商户动态验证码绑定',
  scan: '扫描二维码获取验证码输入',
  authcode: '请输入验证码',
  codenull: '验证码不能为空',
  label: {
    amount: '金额',
    merchatNo: '商户号',
    walletTypeTransferIn: '转入钱包类型',
    walletTypeTransferOut: '转出钱包类型',
    usdt_qr: 'USDT钱包',
    walletTile: '钱包余额详情',
    all: 'all钱包',
    kou: '人工扣款',
    recharge: '人工充值',
    bank_online: '银行钱包',
    bank_qr: '银行二维码',
    QR_TOP: 'QRPro支付',
    QR_PRO: 'QR_PRO',
    zalo_transfer: 'zalo转账',
    bank_transfer: '银行卡转账',
    card_pc: '充值卡',
    card_zing: 'Zing充值卡',
    momo_fix_qr: 'MOMO固码',
    payout: '代付钱包',
    momo_qr: 'MOMO二维码',
    viettel_fix_qr: 'Viettel固码',
    viettel_qr: 'Viettel二维码',
    zalo_qr: 'Zalo二维码',
    qrProBalance: 'QRPro余额',
    viettelBalance: 'viettel余额',
    viettelFixBalance: 'viettel固码余额',
    zaloBalance: 'zalo余额',
    momoBalance: 'momo余额'
  },
  rules: {
    amount: {
      required: '金额不能为空',
      type: '金额必须为数字',
      typeinteger: '金额必须为数字,且必须是整数',
      max: '金额不能大于余额'
    },
    remark: {
      required: '备注不能为空'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/merchantdetails.js